document.addEventListener("DOMContentLoaded", iniciarColeccion);


function esMovil(){
    return window.matchMedia("(max-width: 768px)").matches;
}

function bindEvents(){
    document.querySelectorAll(".art-filter-checkbox").forEach(box => {
        box.removeEventListener("change", aplicarFiltros);
        if(!esMovil()){
            box.addEventListener("change", aplicarFiltros);
        }
    });
    document.querySelectorAll(".art-price-checkbox").forEach(box => {
        box.removeEventListener("change", aplicarFiltros);
        if(!esMovil()){
            box.addEventListener("change", aplicarFiltros);
        }
    });
    const sort = document.getElementById("artSort");
    if(sort){
        sort.onchange = aplicarFiltros;
    }
    const minPrice = document.getElementById("artMinPrice");
    if(minPrice){
        minPrice.onchange = aplicarFiltros;
    }
    const maxPrice = document.getElementById("artMaxPrice");
    if(maxPrice){
        maxPrice.onchange = aplicarFiltros;
    }
    const clearFilters = document.getElementById("artClearFilters");
    if(clearFilters){
        clearFilters.onclick = limpiarFiltros;
    }
    const applyFilters = document.getElementById("artApplyFilters");
    if(applyFilters){
        applyFilters.onclick = aplicarFiltros;
    }
    const openFilters = document.getElementById("artOpenFilters");
    if(openFilters){
        openFilters.onclick = abrirSidebarMovil;
    }
    const closeFilters = document.getElementById("artCloseFilters");
    if(closeFilters){
        closeFilters.onclick = cerrarSidebarMovil;
    }
    const sidebarOverlay = document.getElementById("artSidebarOverlay");
    if(sidebarOverlay){
        sidebarOverlay.onclick = cerrarSidebarMovil;
    }
}

function iniciarColeccion(){
    bindEvents();
    actualizarBotonLimpiar();
    inicializarMostrarMas();
}

async function aplicarFiltros() {

    const params = new URLSearchParams(window.location.search);

    //params.set("view", "artemisa");

    [...params.keys()].forEach(key => {

        if (key.startsWith("filter.")) {
            params.delete(key);
        }
    });

    document.querySelectorAll(".art-filter-checkbox:checked").forEach(check => {
        params.append(check.value, check.dataset.value);
    });

    document.querySelectorAll(".art-price-checkbox:checked").forEach(check => {
        const datos = new URLSearchParams(check.value);
        datos.forEach((valor, llave) => {
            params.set(llave, valor);
        });
    });

    document.querySelectorAll(".art-price-checkbox:checked").forEach(check => {

        const valores = check.value.split("&");

        valores.forEach(valor => {

            const partes = valor.split("=");

            params.set(partes[0], partes[1]);

        });

    });

    const min = document.getElementById("artMinPrice");

    if (min && min.value !== "") {
        params.set("filter.v.price.gte", min.value);
    }

    const max = document.getElementById("artMaxPrice");

    if (max && max.value !== "") {
        params.set("filter.v.price.lte", max.value);
    }

    const sort = document.getElementById("artSort");

    if (sort) {
        params.set("sort_by", sort.value);
    }

    const url = window.location.pathname + "?" + params.toString();

    history.pushState({}, "", url);

    await cargarColeccion(url);

}

async function cargarColeccion(url) {

    const respuesta = await fetch(url);
    const html = await respuesta.text();
    const parser = new DOMParser();
    const documento = parser.parseFromString(html, "text/html");
    const nuevoLayout = documento.querySelector("#artLayout");
    const layoutActual = document.querySelector("#artLayout");

    if (nuevoLayout && layoutActual) {
        cerrarSidebarMovil();
        layoutActual.innerHTML = nuevoLayout.innerHTML;
    }

    // Volvemos a conectar todos los eventos
    bindEvents();
    actualizarBotonLimpiar();
    inicializarMostrarMas();
}


async function limpiarFiltros(){
    const params = new URLSearchParams(window.location.search);

    [...params.keys()].forEach(key => {
        if (key.startsWith("filter.")) {
            params.delete(key);
        }
    });

    const url = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
    history.pushState({}, "", url);
    await cargarColeccion(url);
}

function actualizarBotonLimpiar() {
    const boton = document.getElementById("artClearFilters");
    if (!boton) return;
    const params = new URLSearchParams(window.location.search);
    let activo = false;

    params.forEach((v, k) => {
        if (k.startsWith("filter.")) {
            activo = true;
        }
    });

    boton.style.display = activo ? "block" : "none";
}

window.addEventListener("popstate", () => {
    cargarColeccion(window.location.href);
});


function abrirSidebarMovil(){
    document.querySelector(".art-sidebar")?.classList.add("open");
    document.getElementById("artSidebarOverlay")?.classList.add("open");
    document.body.style.overflow="hidden";
}

function cerrarSidebarMovil(){
    document.querySelector(".art-sidebar")?.classList.remove("open");
    document.getElementById("artSidebarOverlay")?.classList.remove("open");
    document.body.style.overflow="";
}

function inicializarMostrarMas(){
    const boton = document.getElementById("artLoadMore");
    if(!boton) return;
    boton.onclick = () => {
        const ocultos = document.querySelectorAll(".art-product-item[style*='display:none']");
        ocultos.forEach((producto, indice)=>{
            if(indice < 24){
                producto.style.display = "";
            }
        });

        const restantes = document.querySelectorAll(".art-product-item[style*='display:none']");
        if(restantes.length === 0){
            boton.remove();
        }
    };
}

function agregarAlCarrito(variantId, boton){
  const textoOriginal = "Agregar al carrito";

  boton.disabled = true;
  boton.style.opacity = ".7";
  boton.innerHTML = "Agregando...";

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then((item) => {
    boton.innerHTML = "Agregado";
    boton.style.background = "#23694d";

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.renderContents(item);
    }

    setTimeout(() => {
      boton.innerHTML = textoOriginal;
      boton.disabled = false;
      boton.style.opacity = "1";
      boton.style.background = "#2F8561";
    }, 1000);
  })
  .catch(() => {
    boton.innerHTML = textoOriginal;
    boton.disabled = false;
    boton.style.opacity = "1";
  });
}

/*
function agregarAlCarrito(variantId, boton){
  const textoOriginal = "Agregar al carrito";

  boton.disabled = true;
  boton.style.opacity = ".7";
  boton.innerHTML = "Agregando...";

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then((item) => {
    boton.innerHTML = "Agregado";
    boton.style.background = "#23694d";

    actualizarBurbujaCarrito(item.sections['cart-icon-bubble']);
    mostrarPopupCarrito(item);

    setTimeout(() => {
      boton.innerHTML = textoOriginal;
      boton.disabled = false;
      boton.style.opacity = "1";
      boton.style.background = "#2F8561";
    }, 1000);
  })
  .catch(() => {
    boton.innerHTML = textoOriginal;
    boton.disabled = false;
    boton.style.opacity = "1";
  });
}


function actualizarBurbujaCarrito(sectionHtml){
  const wrapper = document.getElementById('cart-icon-bubble');
  if (!wrapper || !sectionHtml) return;

  const html = new DOMParser()
    .parseFromString(sectionHtml, 'text/html')
    .querySelector('.shopify-section');

  if (html) {
    wrapper.innerHTML = html.innerHTML;
  }
}

//popUp mensaje emergente de agregado al carrito
var artPopupTimer = null;
function mostrarPopupCarrito(item){
  const popup = document.getElementById('art-cart-popup');
  if(!popup) return;

  document.getElementById('art-cart-popup-img').src = item.image || '';
  document.getElementById('art-cart-popup-img').alt = item.product_title || '';
  document.getElementById('art-cart-popup-vendor').textContent = item.vendor || '';
  document.getElementById('art-cart-popup-title').textContent = item.product_title || item.title || '';

  popup.classList.add('is-visible');

  if(artPopupTimer){
    clearTimeout(artPopupTimer);
  }

  artPopupTimer = setTimeout(() => {
    cerrarPopupCarrito();
  }, 5000);
}
function cerrarPopupCarrito(){
  const popup = document.getElementById('art-cart-popup');
  if(!popup) return;
  popup.classList.remove('is-visible');

  if(artPopupTimer){
    clearTimeout(artPopupTimer);
    artPopupTimer = null;
  }
}
*/